/**
 * Normalize ENVs
 */

function isTrue(value) {
  if (typeof value === "string") {
    value = value.trim().toLowerCase();
  }
  switch (value) {
    case true:
    case "true":
    case 1:
    case "1":
    case "on":
    case "yes":
      return true;
    default:
      return false;
  }
}

export const {
  REACT_APP_API_SERVER,
  REACT_APP_CDN_SERVER,
  REACT_APP_PROJECT_ID,
  REACT_APP_BOTTLE_SERVICE_API_SERVER,
  REACT_APP_WEB3_AUTH_ID,
  REACT_APP_WEB_SERVER,
  REACT_APP_WERT_PARTNER_ID,
  REACT_APP_WERT_COMMODITY,
  REACT_APP_WERT_ORIGIN,
  REACT_APP_FB_ID,
  REACT_APP_FB_VERIFIER,
  REACT_APP_CDN_PATH,
  REACT_APP_METADATA_SERVICE_PATH,
  REACT_APP_GTM,
  REACT_APP_GOOGLE_ID,
  REACT_APP_GOOGLE_VERIFIER,
  REACT_APP_INFURA_ID,
  REACT_APP_DASHBOARD_REDIRECT,
  REACT_APP_WEB3AUTH_NETWORK,
  REACT_APP_WALLET_CONNECT_PROJECT_ID,
} = typeof window !== "undefined" && window.env ? window.env : process.env;

export const REACT_APP_MAINNET =
  typeof window !== "undefined" && window.env
    ? isTrue(window.env.REACT_APP_MAINNET)
    : isTrue(process.env.REACT_APP_MAINNET);

export const getEnv = (envName) => {
  if (!envName) return null;
  const windowEnvs = typeof window !== "undefined" ? window.env : null;
  const processEnvs = process.env;
  if (envName === "REACT_APP_MAINNET") {
    return REACT_APP_MAINNET;
  }
  if (windowEnvs) {
    return windowEnvs[envName];
  } else if (processEnvs) {
    return processEnvs[envName];
  } else {
    return null;
  }
};
